<div class="kt-login__body auth-right">
    <div class="customer-logo w-100">
      <img [src]="imagePaths.uptimeLogoOriginal" *ngIf="!isLogoAvailable" alt="uptime-logo" width="75em" />
      <img [src]="isLogoAvailable" *ngIf="isLogoAvailable" width="75em" alt="logo" />
    </div>
    <div class="kt-login__form form-body">
        <div class="kt-login__title margin-0 w-470">
          <h5 class="sign-in-text">{{ 'AUTH.VERIFY.VERIFY_EMAIL' | translate }}</h5>
          </div>

          <kt-auth-notice></kt-auth-notice>

          <form class="kt-login__form kt-form margin-0" [formGroup]="verifyForm" autocomplete="off">

            <!-- <div class="form-group form-entity d-flex flex-column">
              <div class="text-color">{{ 'AUTH.INPUT.EMAIL' | translate }}</div>
                <mat-form-field floatLabel="never" class="custom-input-field">
                  <input readonly matInput type="email" placeholder="{{ 'AUTH.INPUT.EMAIL' | translate }}"
                    formControlName="email" autocomplete="off" />
                </mat-form-field>
              </div> -->

              <div class="form-group my-3 form-entity d-flex flex-column">
                <div class="text-color">{{ 'AUTH.GENERAL.ENTER_OTP' | translate }}</div>
                <mat-form-field floatLabel="never" class="custom-input-field">
                  <input matInput type="text" placeholder="{{ 'AUTH.GENERAL.ENTER_OTP' | translate }}"
                    formControlName="otp" autocomplete="off" maxlength="6"/>
                  <mat-error *ngIf="isControlHasError('otp','required')">
                    <strong>{{ 'AUTH.VALIDATION.OTP_REQUIRED' | translate }}</strong>
                  </mat-error>
                  <!-- <mat-error *ngIf="isControlHasError('otp','required')">
                    <strong>{{ 'AUTH.VALIDATION.INVALID_RESET' | translate }}</strong>
                  </mat-error> -->
                  <mat-error *ngIf="isControlHasError('otp','minlength')">
                    <strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 6</strong>
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('otp','maxlength')">
                    <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 6</strong>
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- <mat-checkbox (change)="onRememBerMe($event)">Remember Me</mat-checkbox> -->

              <div class="form-group my-3" *ngIf="recaptcha">
                <re-captcha (resolved)="resolved($event)" siteKey="{{siteKey}}"></re-captcha>
              </div>

              <div class="kt-extra-login__actions w-470 my-3">
                <kt-button-v1
                  variant="flat"
                  class="auth-btn w-100"
                  [fullWidth]="true"
                  (btnClick)="submit()"
                  [disabled]="(isCaptchaSelected && recaptcha) || loading"
                  [style.--auth-bg]="((isCaptchaSelected && recaptcha) || loading) ? '#8B8B8D' : '#6340D5'"
                  [loading]="loading"
                  [label]="'AUTH.GENERAL.VERIFY_BUTTON' | translate">
                </kt-button-v1>
              </div>
              <div class="signup-head my-3"><a routerLink="/web/login" class="signin-back"
                id="kt_login_signup_cancel">{{ 'AUTH.VERIFY.BACK_TO_SIGNIN' | translate }}</a></div>
          </form>
    </div>
</div>
